
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3741_15481)"}},[_c('path',{attrs:{"d":"M19.575 16.625H9.125A1.425 1.425 0 017.7 15.2c0-.044.011-1.132.876-2.2.497-.613 1.18-1.103 2.022-1.448 1.017-.42 2.279-.627 3.752-.627 1.473 0 2.731.211 3.752.627.842.345 1.521.831 2.022 1.447.869 1.07.876 2.153.876 2.201 0 .787-.638 1.425-1.425 1.425zM8.65 15.204c0 .26.215.471.475.471h10.45c.26 0 .475-.212.475-.471 0-.034-.03-.85-.701-1.648-.928-1.102-2.654-1.681-4.999-1.681-2.345 0-4.07.583-4.998 1.681-.672.798-.702 1.614-.702 1.648zM14.35 9.975a3.803 3.803 0 01-3.8-3.8c0-2.097 1.704-3.8 3.8-3.8 2.097 0 3.8 1.703 3.8 3.8 0 2.097-1.703 3.8-3.8 3.8zm0-6.65c-1.57 0-2.85 1.28-2.85 2.85s1.28 2.85 2.85 2.85 2.85-1.28 2.85-2.85-1.28-2.85-2.85-2.85z","fill":"#fff"}}),_c('path',{attrs:{"d":"M2 8.5h6M5.75 6L8 8.5 5.75 11","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3741_15481"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h21v19H0z"}})])])])
          )
        }
      }
    